<div>
  <p class="emoji-gift-cone">🎉</p>
  <h2 class="heading-text">{{'transaction.Transaction' | translate}}</h2>
  <p class="content-text">{{'transaction.order' | translate}}</p>
  <ion-button expand="block" color="medium" class="capsule-btn" type="submit" (click)="proceedNextAction()">
    {{'transaction.Proceed' | translate}}
  </ion-button>
</div>